module.exports = __webpack_public_path__ + "img/LogoBIG.2e3203d8.png";